(function () {
  angular.module('kareo.ui.shared.directives.billing-workflow.search-work-item',
    ['kareo.ui.shared.modules.data',
      'kareo.ui.shared.directives.billing-workflow.list-scroll',
      'kareo.ui.shared.directives.billing-workflow.focus-input',
      'kareo.ui.shared.modules.featureSet'])
   .directive('searchWorkItem',
      () => {
        return {
          template: require('./search-work-item.pug')(),
          restrict: 'E',
          controller: workItemSearchController,
          controllerAs: 'vm',
          link: workItemSearchLink,
          scope: {
            searchPlaceholder: '@',
            focusText: '@',
            alphaMultiscope: '=?',
            numericMultiscope: '=?',
            searchCallback: '&'
          },
          bindToController: true
        };
      });
  // Required modules injected for Controller functionality.
  workItemSearchController.$inject = ['$sce', 'patients', 'featureSet'];
  // Directive link implementation.
  function workItemSearchLink(scope, element, attrs, ctrl) {
    const el = element[0];
    const onElement = angular.element(el.getElementsByClassName('search-results'));
    const outSideElement = angular.element(el.ownerDocument);
    const inputElement = angular.element(el.getElementsByTagName('input'));
    const KEYBOARD__EVENT_ENTER = 13;
    function autoPopulationListHandler(event) {
      if (event.target.id !== 'work_item_search_input' &&
      !(/(matchedRecordClass|srl-header-li|srl-header)/g).test(event.target.className)) {
        scope.vm.searchAlpha = false;
        scope.vm.searchNumeric = false;
        scope.vm.searchAlphaMultiscope = false;
        scope.vm.searchListActive = false;
        scope.vm.patientsList = [];
        scope.vm.showMatchedRecord = !!scope.vm.searchText;
        scope.vm.inputFocus = false;
      }
    }
    function kedownEnterHandler(event) {
      if (!scope.vm.workItemSearchText) {
        scope.vm.searchListActive = false;
      }
      if (event.keyCode === KEYBOARD__EVENT_ENTER) {
        var selectedItem = event.target.parentElement.getElementsByClassName('selected');
        var selectedEle = angular.element(selectedItem[0]);
        if (selectedEle.length && scope.vm.workItemSearchText) {
          if (selectedEle.scope().patient) {
            var patientId = selectedEle.scope().patient.patientId;
            scope.vm.searchItem(patientId, 'patientId');
          } else if (selectedEle.scope().scopeText) {
            var searchType = selectedEle.scope().scopeText.split(':')[1];
            scope.vm.searchItem(scope.vm.workItemSearchText, searchType);
          }
        } else if (!scope.vm.workItemSearchText) {
            scope.vm.searchItem(null, 'clear');
          }
        scope.vm.searchListActive = false;
        event.target.blur();
      }
    }
    onElement.bind('click', autoPopulationListHandler);
    outSideElement.bind('click', autoPopulationListHandler);
    inputElement.bind('keydown', kedownEnterHandler);
  }
  // Directive controller implementation.
  function workItemSearchController($sce, Patients, featureSet) {
    var vm = this;
    vm.patientsList = [];
    vm.searchAlpha = false;
    vm.searchNumeric = false;
    vm.searchAlphaMultiscope = false;
    vm.searchListActive = false;
    vm.workItemSearchText = undefined;
    vm.searchItem = searchItem;
    vm.noResult = false;
    vm.onChange = onChange;
    vm.resultSpanClick = resultSpanClick;

    featureSet.load().then(loadFeatureToggle);

    var hasPatientSearchFeatureEnabled = false;

    function loadFeatureToggle(features) {
        hasPatientSearchFeatureEnabled = features['dark-feature.patient-search-consistency-issues'];
    }

    function resultSpanClick() {
      vm.showMatchedRecord = false;
      vm.workItemSearchText = vm.searchText;
      vm.inputFocus = true;
    }
    var searchHighlight = function (str) {
      var i,
len1,
t,
terms;
      if (!vm.workItemSearchText) {
        return;
      }
      terms = vm.workItemSearchText.split(' ');
      for (i = 0, len1 = terms.length; i < len1; i++) {
        t = terms[i];
        if (!t) {
          continue;
        }
        str = str.replace(new RegExp('(^|[^</>]|\w|\s|$)(' + t + ')(^|\w|\s|[^</>]|$)', 'ig'), '$1<b>$2</b>$3');
      }
      return str; // eslint-disable-line
    };
    function searchItem(searchItemID, searchType) {
      vm.searchType = null;
      vm.searchText = null;
      vm.showMatchedRecord = true;
      vm.searchCallback()(searchItemID, searchType);
      if (searchType === 'patientId') {
        vm.patientsList.forEach((index) => {
          if (index.patientId === searchItemID) {
            vm.searchType = 'Patient' + ': ';
            var fullName = index.lastName + ' ' + index.firstName;
            vm.searchText = fullName;
          }
        });
      } else if (searchType === 'clear') {
        vm.workItemSearchText = searchItemID;
        vm.showMatchedRecord = false;
      } else {
        vm.searchType = searchType + ': ';
        vm.searchText = searchItemID;
      }
    }

    function searchFullName() {
      Patients.searchFullName(vm.workItemSearchText).then((result) => {
        var fullName,
highlighted,
i,
len1,
p;
        vm.patientsList = [];
        if (!result.length) {
          vm.searchAlpha = false;
          if (!vm.searchAlphaMultiscope) {
            vm.noResult = true;
          }
        }

        var regex = /^[a-zA-Z\s]+$/g;

        if (hasPatientSearchFeatureEnabled) {
            regex = /^[a-zA-Z\s,]+$/g;
        }

        if ((regex).test(vm.workItemSearchText)) {
          for (i = 0, len1 = result.length; i < len1; i++) {
            vm.searchAlpha = true;
            vm.noResult = false;
            p = result[i];
            fullName = p.lastName + ', ' + p.firstName;
            highlighted = searchHighlight(fullName);
            highlighted += ' - ' + p.dob().format('DD MMM YYYY');
            p._fullNameHighlighted = $sce.trustAsHtml(highlighted);
            vm.patientsList.push(p);
          }
        } else {
          vm.patientsList = [];
        }
      }, (error) => {
        vm.searchAlpha = false;
        vm.noResult = true;
      });
    }

    function onChange() {
      var ref = vm.workItemSearchText ? vm.workItemSearchText.length : void 0;
      if (ref > 0) {
        vm.searchAlpha = false;
        vm.searchNumeric = false;
        vm.searchAlphaMultiscope = false;
        vm.noResult = false;
        vm.searchListActive = true;

        var regex = /^[a-zA-Z\s]+$/g;

        if (hasPatientSearchFeatureEnabled) {
          regex = /^[a-zA-Z\s,]+$/g;
        }

        if ((regex).test(vm.workItemSearchText)) {
        // For Patient Name
          if (vm.alphaMultiscope && vm.alphaMultiscope.length > 0) {
            vm.searchAlphaMultiscope = true;
          }
          searchFullName();
        } else if ((/^\d+$/g).test(vm.workItemSearchText)) {
          vm.searchNumeric = true;
        } else {
          vm.noResult = true;
        }
      } else {
        vm.patientsList = [];
        vm.searchListActive = false;
      }
    }
  }
})();
